console.log('✅ buildComponentPageCreateStore loaded successfully!');

import { appState } from '../../js/state.js';

import { registerEventListenerToAttach } from '../../js/to-attach-event-listener-registry.js';
import { isNodeEnvironment } from '../../js/utils-fetch-data-json.js';

export async function buildComponentPageCreateStore() {
  console.log(
    `🔄 Building Component: buildComponentPageCreateStore - lang: ${appState.SiteLanguageCookie}`
  );

  try {
    const skeleton = await buildPageSkeleton();

    //By calling registerEventListenerToAttach() immediately, you wire up your hydration callback without delaying the paint.

      registerEventListenerToAttach(async () => initbuildComponentPageCreateStore("CreateStore"));
   // registerEventListenerToAttach(initbuildComponentPageCreateStore);

    if (!isNodeEnvironment()) return skeleton;

      return await buildActualContent("CreateStore");

    return html;
  } catch (err) {
    console.error('❌ Error building buildComponentPageCreateStore:', err);
    return '<div>buildComponentPageCreateStore could not be loaded.</div>';
  }
}

export async function buildPageSkeleton() {
  // Top two “featured” cards
  const topCardsSkeletonHtml = `
      <br />
    <div class="grid-blog-home-bottom-section-card my-fake-image-height-250">
        <div class="my-site-lazy-loading-card">
            <div class="my-site-lazy-loading-card-movement"></div>
        </div>
    </div>
  `;

  let middleCardsSkeleton = '';
  for (let i = 0; i < 12; i++) {
    middleCardsSkeleton += `
      <div class="grid-blog-home-all-category-section-card my-fake-image-height-400">
                            <div class="my-site-lazy-loading-card">
                                <div class="my-site-lazy-loading-card-movement"></div>
                            </div>
                        </div>

                        
    `;
  }

  const html = `

    <div id="placeholder-buildComponentPageCreateStore">
  
   
    <center>

    <div class="myPageMargins">
       

                 ${middleCardsSkeleton}
       
    </div>

    </center>


     </div> 
    
   
  `;

  return html;
}

export async function initbuildComponentPageCreateStore(selectedPageType) {
  try {
    console.log('✅ buildComponentPageCreateStore event listeners attached.');

    const container = document.querySelector('#placeholder-buildComponentPageCreateStore');
    if (!container) return;

    //This touches only the <div id="placeholder-…"> subtree. The rest of the page (header, footer, global scripts) is completely untouched, so the browser can preserve layout and styles. *** FYI Only - innerHTML result in the browser reflowing the entire page, which is expensive.
      container.outerHTML = await buildActualContent(selectedPageType);


      const { initbuildComponentCompanyDetailsComponent } = await import(
          /* webpackChunkName: "company-details-component" */

          '../account/components/shared-guest-business-personal-and-store/company-details-component.js'
      );

      await initbuildComponentCompanyDetailsComponent(selectedPageType);


  } catch (error) {
    console.error('❌ Error attaching event listeners to buildComponentPageCreateStore:', error);
  }
}

export async function buildActualContent(selectedPageType) {


    const { buildComponentCompanyDetailsComponent } = await import(
    /* webpackChunkName: "company-details-component" */

        '../account/components/shared-guest-business-personal-and-store/company-details-component.js'
  );



  // Build the HTML
    let fullComponent = await buildComponentCompanyDetailsComponent(selectedPageType);

    let html = `

    <div class="MainContentContainer-Regular">

       <div class="myPageMargins-Double">

        ${fullComponent}
    
        </div>

    </div>

    <div class="safe-footer"></div>
    `;


  return html;
}

export async function buildComponentPageCreateStoreHeaderTags() {
  const [{ fetchPageSEOTagsAsync }] = await Promise.all([
    import(
      /* webpackChunkName:"seo-data-service", webpackPrefetch: true */ '../../services/data-services/seo-data-service.js'
    ),
  ]);

  let result = '';

  const currentPageSEOAPIResult = await fetchPageSEOTagsAsync('keyCreateStore');

  //alert("blogCategory: " + JSON.stringify(blogCategory));

  if (!currentPageSEOAPIResult) {
    console.log('❌ Error: page seo for buildComponentPageCreateStore not found');

    return result;
  }

  result = currentPageSEOAPIResult;

  return result;
}
